const text = `
# Partneři:
`
const sponsors = [
  {
    name: 'Silicon Hill',
    logo: require('../resources/sponsors/logo_sh.png'),
    link: 'http://www.siliconhill.cz/',
  },
  {
    name: 'AVC',
    logo: require('../resources/sponsors/avc_logo.png'),
    link: 'http://avc.siliconhill.cz/',
  },
  {
    name: 'FEL',
    logo: require('../resources/sponsors/logo_FEL.png'),
    link: 'http://www.fel.cvut.cz/',
  },
  {
    name: 'NIX',
    logo: require('../resources/sponsors/logo_nix.png'),
    link: 'http://www.nix.cz/',
  },
  {
    name: 'FIT',
    logo: require('../resources/sponsors/logo_FIT.png'),
    link: 'http://www.fit.cvut.cz/',
  },
  {
    name: 'SU',
    logo: require('../resources/sponsors/ow_su_logo.png'),
    link: 'http://www.su.cvut.cz/',
  },
  {
    name: 'hwkitchen',
    logo: require('../resources/sponsors/hwkitchen.png'),
    link: 'http://www.hwkitchen.com/',
  },
  {
    name: 'root',
    logo: require('../resources/sponsors/root-if.png'),
    link: 'http://root.cz/',
  },
  {
    name: 'active24',
    logo: require('../resources/sponsors/barevnelogo_a24.png'),
    link: 'http://active24.cz/',
  },
  {
    name: 'cznic',
    logo: require('../resources/sponsors/cznic.png'),
    link: 'https://akademie.nic.cz/',
  },
  {
    name: 'cesnet',
    logo: require('../resources/sponsors/cesnet-logo.png'),
    link: 'http://cesnet.cz/',
  },
  {
    name: 'bastliri',
    logo: require('../resources/sponsors/bastliri.png'),
    link: 'http://macgyver.sh.cvut.cz/',
  },
  {
    name: 'vpsFree',
    logo: require('../resources/sponsors/vpsfree.png'),
    link: 'http://www.vpsfree.cz/',
  },
  {
    name: 'SUSE',
    logo: require('../resources/sponsors/suse_logo.png'),
    link: 'http://www.suse.com/',
  },
  {
    name: 'Red Hat',
    logo: require('../resources/sponsors/red_hat_logo.png'),
    link: 'http://www.redhat.com/',
  },
]

export default {
  text,
  sponsors,
}



// WEBPACK FOOTER //
// ./src/content/installfest/sponsors/partners.js